export default __webpack_public_path__ + "static/media/logo-alice.80d1baf5.png";